import { render } from "./AttendaceTable.vue?vue&type=template&id=89603d58&scoped=true"
import script from "./AttendaceTable.vue?vue&type=script&lang=js"
export * from "./AttendaceTable.vue?vue&type=script&lang=js"

import "./AttendaceTable.vue?vue&type=style&index=0&id=89603d58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89603d58"]])

export default __exports__